export default __webpack_public_path__ + "static/media/checkmark.4c9e792e.svg";